// extracted by mini-css-extract-plugin
module.exports = {"row":"OtpInput_row__oCIh_","group":"OtpInput_group__WhFht","box":"OtpInput_box__zvnjE","error":"OtpInput_error__mTew0"};